<template>
    <v-card class="rounded-xl" width='400'>

        <v-card-text class="d-flex align-center justify-center">

            <v-img class="logo" max-width="200" max-height="200" alt="logo" src="../../../assets/logo-lateral.webp"></v-img>
            
        </v-card-text>
        
        <v-card-text class="text-center">

            <p>{{$t('dash_plans.plan_system_description')}}</p>

        </v-card-text>

        <v-card-actions>

            <v-btn @click="goToPlanAdmin" :loading='loading' rounded block color='#4ec5c1' class="my-2 btn-to-payment">{{$t('dash_plans.checkout_plans')}}</v-btn>

        </v-card-actions>

    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CardPlanAdmin',

    data() {
        return {
            loading: false
        }
    },

    computed: {

        ...mapGetters({
            account: 'AccountVuex/account',
            generalConfigs: 'generalConfigs'
        }),

    },
    methods: {
        goToPlanAdmin() {

            this.loading = true

            this.showToast(this.$t('redirect'), this.$t('plans'), 'info')

            try {

                if (this.account?.status === 'Incomplete') {

                console.log(this.generalConfigs.signup_url)

                const f = document.createElement('form');
                f.action = this.generalConfigs.signup_url
                f.method = 'POST';

                const i = document.createElement('input');
                i.type = 'hidden';
                i.name = 'token';
                i.value = localStorage.getItem('token')
                f.appendChild(i);

                document.body.appendChild(f);

                return f.submit();


            } else {

                const f = document.createElement('form');
                f.action = this.generalConfigs.payment_url
                f.method = 'POST';

                const i = document.createElement('input');
                i.type = 'hidden';
                i.name = 'token';
                i.value = localStorage.getItem('token')
                f.appendChild(i);

                document.body.appendChild(f);

                return f.submit();

            }   
                
            } catch (error) {

                this.loading = false

                return this.showToast(this.$t('plans'), this.$t('provider_register.toast_error_plans_msg'), 'error')
                
            }

            
        }
    },

}

</script>

<style>

</style>